import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminLogin from "./components/AdminLogin";
import UserManagement from "./components/UserManagement";
import ConnectionRequests from "./components/ConnectionRequests";
import ExpirationIntervals from "./components/ExpirationIntervals";
import ResetPassword from "./components/ResetPassword";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/users" element={<UserManagement />} />
        <Route path="/requests" element={<ConnectionRequests />} />
        <Route path="/expiration-intervals" element={<ExpirationIntervals />} />
        <Route path="*" element={<AdminLogin />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Routes>
    </Router>
  );
}

export default App;
